import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { Input } from "antd";
import { FormattedMessage, useIntl } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import InfiniteScroll from "react-infinite-scroller";
import { getInitials } from "../../libs/utils";
import { sessionStart } from "../../store/actions/analytics/index";
import useChangeCompany from "../../customHooks/useChangeCompany";

const CompanyList = ({ changeFullTextSearch,
  companyName,
  searchTerm,
  setNewPageCompanies}) => {

  const company = useSelector(state => state.company);
  const main = useSelector(state => state.main);
  const companies = company.companies;
  const hasMoreItems = company.hasMoreItems;
  const preSearchedCompany = company.preSearchedCompany;
  const searchedCompany = company.searchedCompany;

  const {changeCompanySelected} = useChangeCompany();
  const inputEl = useRef(null);
  // serve a gestire le chiamate
  const timerToSearching = useRef(null); // now you can pass timer to another component
  const selectCompanyPlaceholder = useIntl().formatMessage({
    id: "generic.selectCompanyPlaceholder"
  });

  // dal 3 carattere in poi
  const [changedChar, setChangedChar] = useState("");
  const [startSearch, setstartSearch] = useState(false);

  const {clearDefaultCompany} = useChangeCompany();

  useEffect(() => {
    if (searchTerm === "" && !main.companySelected) {
      inputEl.current.focus();
    }
  }, [searchTerm, main.companySelected]);

  useEffect(() => {
    // Se cambia un carattere entro 500 ms pulisco il timer
    clearInterval(timerToSearching.current);

    timerToSearching.current = setInterval(() => setstartSearch(true), 500);

    return () => {
      clearInterval(timerToSearching.current);
    };
  }, [changedChar]);

  useEffect(() => {
    changeFullTextSearch(changedChar);
  }, [startSearch]);

  const dispatch = useDispatch();

  const renderCompaniesList = () => {
    // const arrayToView = companies;
    const arrayToView =
      searchTerm === "" && preSearchedCompany ? preSearchedCompany : (searchTerm?.length > 3 ? searchedCompany : companies);

    return (
      <div style={{ position: "absolute", top: "64px" }}>
        <div
          style={{
            transform: "translateZ(0px)",
            backgroundColor: "#5a6872",
            width: "390px",
            height: "100%",
            position: "relative"
          }}
        >
          <ul className="list-dropdownMenu">
            {arrayToView?.length > 0 ? (
              <InfiniteScroll
                initialLoad={false}
                pageStart={1}
                loadMore={
                  arrayToView?.length > 38 ? setNewPageCompanies : () => {}
                }
                hasMore={arrayToView?.length > 38 && hasMoreItems}
                loader={
                  <div
                    key="loaderCompanies"
                    style={{ textAlign: "center", color: "#FFF" }}
                  >
                    <FontAwesomeIcon icon={["far", "circle-notch"]} spin />
                  </div>
                }
                threshold={0}
                useWindow={false}
              >
                {arrayToView.map(el => {
                  const logoUrl = el?.logoUrl;
                  return (
                    <li
                      key={"liList_" + el.id}
                      onClick={e => {
                        e.preventDefault();
                        e.stopPropagation();
                        dispatch(sessionStart(el.uuid));
                        changeCompanySelected(el.id, el);
                      }}
                    >
                      <div
                        className="optionLiAutoComplete gs-change-company"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        { !logoUrl ?
                          <div
                            className="roundUser"
                            style={{ marginRight: "5px" }}
                          >
                            <span>
                              {el.ragioneSociale
                                ? getInitials(el.ragioneSociale)
                                : "N/A"}{" "}
                            </span>
                          </div>
                          : <div className="dbx-header-logo-container" style={{backgroundImage: `url(${logoUrl})`}}></div>
                        }
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <span>{el.ragioneSociale}</span>
                          <span className="txtSmall">
                            <FormattedMessage id="generic.shortTaxIdentifier" /> {el.codiceFiscale}
                          </span>
                        </div>
                      </div>
                    </li>
                  );
                })}
              </InfiniteScroll>
            ) : (
              <li onClick={e => {
                e.preventDefault();
                e.stopPropagation();
              }} style={{ color: "#FFF", textAlign: "" }}>
                <FormattedMessage id="generic.noSearchCompany"/>
              </li>
            )}
          </ul>
        </div>
      </div>
    );
  };

  return (
    companies && (
      <div
        style={{ display: "flex", alignItems: "center" }}
        onClick={clearDefaultCompany}
      >
        <div
          style={{ cursor: "pointer" }}
          className={
            "clienteEsteso " +
            (main.myType === "STUDIO" ? " clienteEstesoBianco" : "")
          }
        >
          <div className="fakeSelect">
            <span style={{ marginLeft: "10px" }}>
              {main.companySelected && companyName}{" "}
              {!main.companySelected && (
                <Input
                  style={{
                    backgroundColor: "transparent",
                    border: 0,
                    padding: 0,
                    width: "calc(100% - 20px",
                    color: main.myType === "STUDIO" ? "#000" : "#FFF"
                  }}
                  onChange={e => {
                    const changedVal = e.target.value;
                    setChangedChar(changedVal);
                    setstartSearch(false);
                  }}
                  placeholder={selectCompanyPlaceholder}
                  ref={inputEl}
                />
              )}
            </span>
            <div className="companyCF"> <FormattedMessage id="generic.shortTaxIdentifier" /> {main.companySelected}</div>
          </div>
        </div>

        {!main.companySelected && renderCompaniesList()}
        <FontAwesomeIcon
          icon={["far", "angle-" + (main.companySelected ? "down" : "up")]}
          style={{
            color: main.myType === "STUDIO" ? "#152935" : "#FFF",
            cursor: "pointer",
            fontSize: "20px"
          }}
        />
      </div>
    )
  );
};

CompanyList.propTypes = {
  changeFullTextSearch: PropTypes.func,
  companyName: PropTypes.string,
  searchTerm: PropTypes.string,
  setNewPageCompanies: PropTypes.func
};

export default CompanyList;
